import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


export async function obtenerExcel({ token, params }) {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.EXCEL.GET_REPORT}`, extraHeaders: { token: token }, params: params });
    return response
}

